import { render, staticRenderFns } from "./InformativeFilter.vue?vue&type=template&id=06f0c324&"
import script from "./InformativeFilter.vue?vue&type=script&lang=js&"
export * from "./InformativeFilter.vue?vue&type=script&lang=js&"
import style0 from "./InformativeFilter.vue?vue&type=style&index=0&id=06f0c324&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports